module.exports = __webpack_public_path__ + "static/media/lisa_desktop_1_resized.702ed268.webp";